import { render, staticRenderFns } from "./SubSession.vue?vue&type=template&id=5954d4c4&"
import script from "./SubSession.vue?vue&type=script&lang=js&"
export * from "./SubSession.vue?vue&type=script&lang=js&"
import style0 from "./SubSession.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports